<template>
  <div>
    <progress-bar ref='progressBar' :val='this.$data.data.prosess' :text='this.$data.data.prosess+"%"'></progress-bar>
  </div>
</template>

<script>
  import ProgressBar from 'vue-simple-progress';
  export default {
    name: 'ProcessBarChain',
    components: {
      ProgressBar
    },
    data() {
      return {
      };
    }
  };
</script>
